// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5932":"66d699c4","6607":"a2f530d3","8015":"b558db09"}[chunkId] + ".chunk.css";
};